'use client'

import {useState} from 'react'
import {Lightbox, ZoomIcon, type LightboxImage} from './Lightbox'
import {RichTextInline} from './RichText'
import type {RichTextValue} from '@/lib/richtext'

export type TestimonialItem = {
  id: string
  title?: string | null
  quote: RichTextValue
  image?: {thumb: string; full: string; alt: string} | null
}

export function TestimonialGallery({items}: {items: TestimonialItem[]}) {
  // Only testimonials with an image participate in the lightbox gallery.
  const gallery = items.filter((i) => i.image)
  const lightboxImages: LightboxImage[] = gallery.map((g) => ({
    full: g.image!.full,
    alt: g.image!.alt,
    caption: g.title,
  }))
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  return (
    <>
      <div className="t-grid reveal">
        {items.map((it) => {
          const gi = it.image ? gallery.findIndex((g) => g.id === it.id) : -1
          const thumb = it.image ? (
            <span className="tcard-thumb-wrap">
              <img className="tcard-thumb" src={it.image.thumb} alt={it.image.alt} loading="lazy" />
              <span className="tcard-zoom" aria-hidden="true">
                <ZoomIcon />
              </span>
            </span>
          ) : null
          const body = (
            <span className="tcard-body">
              {it.title && <h3>{it.title}</h3>}
              <p>“<RichTextInline value={it.quote} />”</p>
            </span>
          )

          if (gi >= 0) {
            return (
              <button
                key={it.id}
                type="button"
                className="tcard clickable"
                onClick={() => setOpenIndex(gi)}
                aria-label={`View image${it.title ? ` for “${it.title}”` : ''}`}
              >
                {thumb}
                {body}
              </button>
            )
          }
          return (
            <div key={it.id} className="tcard">
              {thumb}
              {body}
            </div>
          )
        })}
      </div>

      <Lightbox images={lightboxImages} openIndex={openIndex} setOpenIndex={setOpenIndex} />
    </>
  )
}
